import { CandidateWorkExperienceStatus } from '@flex-apis/recruiting';
import type { SelectProps } from '@flex-design-system/fx';
import { Button, Select } from '@flex-design-system/fx';
import { ChevronDownMiniIcon } from '@flex-design-system/legacy-flex-icons';
import { Translation } from '@flex-packages/i18n';
import { trans } from '@flex-packages/i18n-base';

import {
  isCandidateWorkExperienceStatus,
  WORK_EXPERIENCE_STATUS_CONTENT,
} from '../../../base';

type Props = Omit<SelectProps, 'children'>;

const WORK_EXPERIENCE_STATUS_TYPES: Array<CandidateWorkExperienceStatus> = [
  CandidateWorkExperienceStatus.InEmploy,
  CandidateWorkExperienceStatus.Resignation,
];

const WorkExperienceStatusSelect = (props: Props) => {
  return (
    <Select {...props}>
      <Select.Trigger asChild>
        <Button
          type="button"
          variant="outline"
          size="xsmall"
          color="gray"
          rightSlot={<ChevronDownMiniIcon size={16} color="grayLight" />}
        >
          {props.value !== undefined &&
          isCandidateWorkExperienceStatus(props.value) ? (
            <Translation
              tKey={WORK_EXPERIENCE_STATUS_CONTENT[props.value].i18n}
            />
          ) : (
            <Translation
              tKey={trans('recruiting.background.status.placeholder')}
            />
          )}
        </Button>
      </Select.Trigger>
      <Select.Content>
        {WORK_EXPERIENCE_STATUS_TYPES.map(type => (
          <Select.Option key={type} value={type}>
            <Select.OptionTitle>
              <Translation tKey={WORK_EXPERIENCE_STATUS_CONTENT[type].i18n} />
            </Select.OptionTitle>
          </Select.Option>
        ))}
      </Select.Content>
    </Select>
  );
};

export default WorkExperienceStatusSelect;
